<template>
    <div id="subPage2">
        <SubHeader/>
        <div class="subPage2">
            <SubMenu2/>
        </div>
        <MainFooter class="subFooter"/>
    </div>
</template>

<script>

import SubMenu2 from '../../submenu/subMenuLi2.vue'
import SubHeader from '@/pages/basic/subHeader.vue'
import MainFooter from '@/pages/basic/mainFooter.vue'

import build from '@/api/example'

export default{
    components: {
        SubMenu2,
        SubHeader,
        MainFooter
    },
    methods: {
        checkLogin() {
            build.get('/mer/api/member')
            .then(res => { //인증된 사용자가 정보가 서버에 있을 경우
                this.$store.state.isLogin = true;

                if(res.data.userSe === 'ADMIN') {
                this.$store.state.isAdmin = true;
                }

                if(res.data.userSe === 'BSN') {
                this.$store.state.isBusiness = true;
                }
            })
            .catch(err => { //인증된 사용자가 정보가 서버에 없을 경우
                this.$store.state.isLogin = false;
                this.$store.state.isAdmin = false;
                this.$store.state.isBusiness = false;
                console.log(err);
            });
        }
    },
    mounted() {
        this.$store.state.popupCheck = true;

        this.checkLogin();
    }
}
</script>

<style scoped>
@import '@/assets/css/reset.css';
    
    #subPage2 {
        position:absolute;
        margin: auto;
        height: auto;
        width: 100% !important;
        align-items: center;
        margin-top: 9.5%;
    }

    .subPage2 {
        max-width: 1197px;
        margin: auto;
        height: auto;
        width: 90%;
    }
    .subFooter {
        position: relative;
        bottom: 0;
        width: 100%;
    }

    @media all and (min-width: 1921px) {

        .subPage2 {
            max-width: 1195px;
        }

    }

    @media all and (min-width: 2279px) {

        .subPage2 {
            max-width: 1190px;
        }

    }

    @media all and (max-width: 1200px) {

        .subPage2 {
            margin: 0;
            width: 99vw;
            height: 30vh;
        }

    }

    
    @media all and (max-width: 960px) {
        
        #subPage2 {
            position:static;
            margin: auto;
            height: auto;
            width: 100% !important;
            align-items: center;
        }

    }


</style>

